// The health "subject" (family member) currently being viewed. Kept as a
// module-level value so the health/oura/whoop service functions can append
// ?member_id= automatically, without every caller threading it through.
//
// Only the Health page sets this; it resets to null (= self) when that page
// unmounts, so other pages (Today, dashboards) always operate on self.

let activeMemberId: string | null = null;

export const setActiveMemberId = (id: string | null): void => {
  activeMemberId = id;
};

export const getActiveMemberId = (): string | null => activeMemberId;

/** Query params for the active member, or {} for self. Spread into axios `params`. */
export const memberParam = (): Record<string, string> =>
  activeMemberId ? { member_id: activeMemberId } : {};
